export type ThemePreference = 'light' | 'dark';

/** Resolve effective theme from localStorage override or system preference. */
export function resolveTheme(): ThemePreference {
  const saved = localStorage.getItem('theme');
  if (saved === 'dark' || saved === 'light') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/** Apply theme class on <html> without writing localStorage. */
export function applyThemeClass(theme: ThemePreference): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

/** Apply theme class and persist explicit user choice. */
export function persistTheme(theme: ThemePreference): void {
  applyThemeClass(theme);
  localStorage.setItem('theme', theme);
}

/** Synchronous init — call before React render to avoid wrong-theme flash. */
export function initTheme(): ThemePreference {
  const theme = resolveTheme();
  applyThemeClass(theme);
  return theme;
}